/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentMethod/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AutoPayment from './AutoPayment/index'
import BankAccountPayment from './BankAccountPayment/index'
import CashPayment from './CashPayment/index'
import CheckPayment from './CheckPayment/index'
import CreditCardPayment from './CreditCardPayment/index'
import InsurancePayment from './InsurancePayment/index'
import No from './No/index'
import OtherPayment from './OtherPayment/index'
import React from 'react'
import TransferPayment from './TransferPayment/index'



/** @type {import('Simple/types.js').View} */
export default function PaymentMethod({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy/PaymentMethod"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentPaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'payment_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentPaymentTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreditCardPayment'}>
<CreditCardPayment
  viewPath={`${viewPath}/CreditCardPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BankAccountPayment'}>
<BankAccountPayment
  viewPath={`${viewPath}/BankAccountPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AutoPayment'}>
<AutoPayment
  viewPath={`${viewPath}/AutoPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InsurancePayment'}>
<InsurancePayment
  viewPath={`${viewPath}/InsurancePayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CashPayment'}>
<CashPayment
  viewPath={`${viewPath}/CashPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckPayment'}>
<CheckPayment
  viewPath={`${viewPath}/CheckPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherPayment'}>
<OtherPayment
  viewPath={`${viewPath}/OtherPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TransferPayment'}>
<TransferPayment
  viewPath={`${viewPath}/TransferPayment`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}